import { useDispatch } from "react-redux";
import { toggleToast } from "../redux/slices/appState/appStateSlice";
import { TOAST_AUTO_HIDE_DURATION } from "../helpers/constants";
import { ToastDisplayType } from "../components";

export const useToast = () => {
  const dispatch = useDispatch();

  const displayToast = (
    errorMessage: string,
    type: ToastDisplayType = "success",
  ) => {
    dispatch(
      toggleToast({
        open: true,
        message: errorMessage,
        type: type,
        autoHideDuration: TOAST_AUTO_HIDE_DURATION,
      }),
    );
  };

  return { displayToast };
};
